import { getInfoDetails } from "@entities/influencer/lib/utils/getInfoDetails";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { Button } from "@shared/ui/Button";
import { InputNumber } from "@shared/ui/InputNumber";
import { Avatar, Descriptions, List, Space, Tag, Typography } from "antd";

const { Text } = Typography;

export function CommercialsTile({
  briefInfluencers,
  costValues,
  type,
  onChange,
}: {
  briefInfluencers: IBriefInfluencerV2[];

  type: "ask" | "give";
  costValues: {
    [key: string]: { isPrimary: boolean; value: number | undefined };
  };
  onChange: (influencerId: string, value: number | undefined) => void;
}) {
  const handleCostChange = (influencerId: string, value: number | null) => {
    onChange(influencerId, value === null ? undefined : value);
  };

  const getPrimaryContactInfo = (influencer: IBriefInfluencerV2) => {
    const creatorInfo = getInfoDetails(influencer);
    if (influencer.primaryContact) {
      return (
        <Descriptions>
          <Descriptions.Item label="Poc Name">
            {creatorInfo.name}
          </Descriptions.Item>
          <Descriptions.Item label="Poc Email">
            {creatorInfo.email}
          </Descriptions.Item>
          <Descriptions.Item label="Poc Phone">
            {creatorInfo.phone}
          </Descriptions.Item>
        </Descriptions>
      );
    }

    return "No primary contact info";
  };

  return (
    <div>
      <List
        dataSource={briefInfluencers}
        style={{ maxHeight: 300, overflow: "auto" }}
        renderItem={(influencer: IBriefInfluencerV2) => (
          <List.Item
            style={{
              background: !influencer.isPrimaryContactAdded
                ? "#F5F5F5"
                : undefined,
              borderRadius: !influencer.isPrimaryContactAdded ? 10 : undefined,
              padding: 10,
            }}
            actions={
              type === "give" && influencer.primaryContact
                ? [
                    <InputNumber
                      key="cost"
                      placeholder="Enter cost"
                      value={costValues[influencer._id]?.value || undefined}
                      onChange={(value) => {
                        handleCostChange(
                          influencer._id,
                          value as number | null
                        );
                      }}
                      style={{ width: 150 }}
                    />,
                  ]
                : undefined
            }
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  src={influencer?.socialMedia?.profilePicUrl}
                  shape="circle"
                  size="large"
                />
              }
              title={
                <Space>
                  <Space align="center">
                    <Button
                      style={{ padding: 0 }}
                      type="link"
                      onClick={() => {
                        window.open(influencer?.socialMedia?.link, "_blank");
                      }}
                    >
                      {getPlatformIcon(influencer?.socialMedia?.platform || "")}
                      <Text strong>{influencer?.socialMedia?.username}</Text>
                    </Button>
                  </Space>
                  {influencer?.primaryContact?.agencyUserId ? (
                    <Tag color="blue">{getInfoDetails(influencer).agency}</Tag>
                  ) : null}
                  {!influencer?.assignedPricingPocV2?.assignedToUserId ? (
                    <Tag color="red">No Pricing POC Assigned</Tag>
                  ) : null}
                </Space>
              }
              description={
                <Space direction="vertical" size="small">
                  <Text type="secondary">
                    {getPrimaryContactInfo(influencer)}
                  </Text>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}
